module.exports = __webpack_public_path__ + "0692484a41241c28ef285a6ea3d539cf.svg";